var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex my-1 align-center font-1"},[_c('v-icon',{staticClass:"mr-3 font-1",attrs:{"color":"base"}},[_vm._v(_vm._s(_vm.item.icon))]),_c('div',[_vm._v(" "+_vm._s(_vm.item.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }